import { render, staticRenderFns } from "./sustainable.vue?vue&type=template&id=4cac3d9c&scoped=true"
import script from "./sustainable.vue?vue&type=script&lang=js"
export * from "./sustainable.vue?vue&type=script&lang=js"
import style0 from "./sustainable.vue?vue&type=style&index=0&id=4cac3d9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cac3d9c",
  null
  
)

export default component.exports